import defaults from '~/utils/newsletterDefaults'

export default {
  computed: {
    newsletterTexts() {
      return { ...defaults, ...this.$store.state.content.newsletterSettings }
    },
    genders() {
      return ['m', 'f', 'n'].map((value) => ({
        value,
        label: this.newsletterTexts[`gender_${value}`],
      }))
    },
  },
  async fetch() {
    try {
      await this.$store.dispatch('content/loadNewsletterSettings')
    } catch {
      // Keep the containing page usable if the CMS globals are unavailable.
    }
  },
}
